'use strict';

export default function f($rootScope, $timeout, userModel) {
  'ngInject';

  const SHOW_TIMEOUT = 200;
  const HIDE_TIMEOUT = 6000;
  const TRANSITION_SHOW_HIDE = 20;
  const ANIMATION_TIMEOUT = 500;

  // TODO: popup interactions

  return {
    navigationElem: null,
    alertText: '',
    show: false,
    preshow: false,

    showAlert(text) {
      if (!userModel.item.id) {
        return;
      }

      this.alertText = text;

      this.timePreShow = $timeout(() => {
        this.preshow = true;
        this.timeShow = $timeout(() => {
          this.show = true;
        }, TRANSITION_SHOW_HIDE);
        this.timeHide = $timeout(() => {
          this.dismiss();
        }, HIDE_TIMEOUT);
      }, SHOW_TIMEOUT);
    },

    cancel() {
      this.preshow = false;
      this.show = false;

      $timeout.cancel(this.timePreShow);
      $timeout.cancel(this.timeShow);
      $timeout.cancel(this.timeHide);
      $timeout.cancel(this.timeDismiss);
    },

    warning(text) {
      this.systemAlertType = 'warning';
      this.showAlert(text);
    },

    success(text) {
      this.systemAlertType = 'tick';
      this.showAlert(text);
    },

    dismiss() {
      this.show = false;
      this.timeDismiss = $timeout(() => {
        this.preshow = false;
      }, ANIMATION_TIMEOUT);
    },
  };
}



// WEBPACK FOOTER //
// ./app/src/components/system_alerts/system_alerts.service.js